const pointMap = new Map([
  ['detail', '/spot/detail/analysis']
]);

export default pointMap;
